import { RemoteFiltersConfiguration, RemoteFiltersFieldType } from 'frontcore/presentation/remote-filters/domain/types'
import { RemoteFiltersValue } from 'frontcore/presentation/remote-filters/domain/remote-filters-value'

import type { LocationQueryValue, RouteLocation, Router } from 'vue-router'

const availableFilterKey: RemoteFiltersConfiguration['filterId'][] = []

const saveAvailableFilterKey = (key: RemoteFiltersConfiguration['filterId']) => {
  if (availableFilterKey.indexOf(key) !== -1) { return }
  availableFilterKey.push(key)
}

const useRemoteFiltersUrl = (route: RouteLocation, router: Router) => {

  const getURLFilterParameter = (configuration: RemoteFiltersConfiguration): RemoteFiltersValue | undefined => {
    let value: string | undefined
    if (configuration.filterType === RemoteFiltersFieldType.DATE_RANGE) {
      const afterFilterKey = `${configuration.filterMap}_after`
      const afterValue = route.query[afterFilterKey]?.toString()
      const beforeFilterKey = `${configuration.filterMap}_before`
      const beforeValue = route.query[beforeFilterKey]?.toString()
      saveAvailableFilterKey(afterFilterKey)
      saveAvailableFilterKey(beforeFilterKey)
      value = beforeValue && afterValue ? `${afterValue},${beforeValue}` : undefined
    } else {
      saveAvailableFilterKey(configuration.filterMap)
      value = route.query[configuration.filterMap]?.toString()
    }
    if (typeof value !== 'string') { return }
    return RemoteFiltersValue.buildFromURL(configuration, value)
  }

  const setURLFilterParameters = (remoteFiltersValues: RemoteFiltersValue[]) => {
    const query: Record<string, LocationQueryValue | LocationQueryValue[] | undefined> = { ...route.query }
    for (const key of availableFilterKey) {
      query[key] = undefined
    }
    for (const remoteFilterValue of remoteFiltersValues) {
      for (const [key, value] of Object.entries(remoteFilterValue.queryParameters ?? {})) {
        query[key] = value
      }
    }
    router.replace({ query }).catch((e) => {
      if (e instanceof Error && e.name === 'NavigationDuplicated') { return }
      throw e
    })
  }

  return {
    getURLFilterParameter,
    setURLFilterParameters,
  }
}

export default useRemoteFiltersUrl
